import React, {useState} from 'react';
import {Link} from 'react-router-dom';
// import {history} from 'appRedux/store';
import {useCollectionData} from 'react-firebase-hooks/firestore';
import {Tabs, List, Dropdown, Menu, Avatar, Drawer} from 'antd';
// import numeral from 'numeral';
// import {FaSpinner} from 'react-icons/fa';
import Widget from 'components/Widget/index';
import Auxiliary from 'util/Auxiliary';
import FirebasePlaid from 'firebase/firebasePlaid';
import MemberEdit from './MemberEdit';

// const spinnerIcon = <FaSpinner size="3" className="icon-spin" />;
// const Search = Input.Search;
const {TabPane} = Tabs;
// const {confirm} = Modal;

const Plaid = () => {
  const accountList = [];
  const [itemList, loading, error] = useCollectionData(
    FirebasePlaid.getAccounts(),
    {
      idField: 'id',
      snapshotListenOptions: {
        includeMetadataChanges: true,
      },
    },
  );

  // const [searchResults, setSearchResults] = useState(null);
  const [tabActive, setTabActive] = useState('0');
  const [showDrawer, setShowDrawer] = useState(false);
  const onDrawerClose = () => setShowDrawer(false);
  // const onDrawerOpen = () => setShowDrawer(true);
  const [memberEdit, setMemberEdit] = useState(null);

  const selectTab = key => {
    setTabActive(key);
  };

  // const editMember = institution => {
  //   onDrawerOpen();
  //   setMemberEdit(institution);
  // };

  const cancelEdit = () => {
    setMemberEdit(null);
    onDrawerClose();
  };

  const options = ['Edit', 'Delete'];

  const memberDropdownMenu = item => (
    <Menu
      onClick={event => {
        if (event.key === 'Edit') {
          // editMember(item);
        } else {
          // deleteMember(item);
        }
      }}>
      {options.map(option => (
        <Menu.Item key={option}>{option}</Menu.Item>
      ))}
    </Menu>
  );

  if (itemList && itemList.length > 0) {
    itemList.forEach(item => {
      let accts = item.metadata.accounts;
      let institution = item.metadata.institution.name;
      accts.forEach(acct => {
        acct.institution = institution;
        accountList.push(acct);
      });
    });
  }

  return (
    <div>
      {error && <strong>Connection error!</strong>}
      {loading && <p>Loading...</p>}
      {accountList && accountList.length > 0 && (
        <Auxiliary>
          <Widget>
            <Tabs type="card" activeKey={tabActive} onChange={selectTab}>
              <TabPane tab="My Accounts" key="0">
                <div>
                  {accountList.length > 0 ? (
                    <List
                      itemLayout="horizontal"
                      dataSource={accountList}
                      renderItem={item => (
                        <List.Item
                          actions={[
                            <div className="gx-module-contact-right">
                              <Dropdown
                                overlay={() => memberDropdownMenu(item)}
                                placement="bottomRight"
                                trigger={['click']}>
                                <i className="gx-icon-btn icon icon-ellipse-v" />
                              </Dropdown>
                            </div>,
                          ]}>
                          <Link
                            to={{
                              pathname: `/app/link/${item.mask}`,
                              guid: item.guid,
                            }}>
                            {/* <InstitutionListItem userItem={item} /> */}
                            <List.Item.Meta
                              avatar={
                                <Avatar
                                  size={48}
                                  src="data:image/png;base64,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"
                                />
                              }
                              title={
                                <span
                                  style={{fontWeight: 400, fontSize: '16px'}}>
                                  {item.institution}
                                </span>
                              }
                              description={
                                <span
                                  style={{
                                    fontWeight: 400,
                                    color: '#aaa',
                                    fontSize: '14px',
                                  }}>
                                  {item.name} - {item.mask}
                                </span>
                              }
                            />
                          </Link>
                        </List.Item>
                      )}
                    />
                  ) : (
                    <h2>
                      You haven't connected any institutions yet. Please go to
                      the "Search institutions" tab to connect your institution
                      now.
                    </h2>
                  )}
                </div>
              </TabPane>

              {/* <TabPane tab="Search Institutions" key="1">
                  <Search
                    placeholder="Name of your financial institution"
                    onSearch={handleSearch}
                    enterButton
                  />
                  {searchResults.map(institution => {
                    return (
                      <Link
                        to={{
                          pathname: `/app/link/${institution.code}`,
                          code: institution.code,
                        }}
                        key={institution.code}>
                        <div style={{borderBottom: '1px solid #eee'}}>
                          <InstitutionListItem
                            searchListItem={institution}
                            search={true}
                          />
                        </div>
                      </Link>
                    );
                  })}
                </TabPane>
                <TabPane tab="Your Institutions" key="2">
                  <div>
                    {memberList.length > 0 ? (
                      <List
                        itemLayout="horizontal"
                        dataSource={memberList}
                        renderItem={item => (
                          <List.Item
                            actions={[
                              <div className="gx-module-contact-right">
                                <Dropdown
                                  overlay={() => memberDropdownMenu(item)}
                                  placement="bottomRight"
                                  trigger={['click']}>
                                  <i className="gx-icon-btn icon icon-ellipse-v" />
                                </Dropdown>
                              </div>,
                            ]}>
                            <Link
                              to={{
                                pathname: `/app/link/member/${item.code}`,
                                guid: item.guid,
                              }}>
                              <InstitutionListItem userItem={item} />
                            </Link>
                          </List.Item>
                        )}
                      />
                    ) : (
                      <h2>
                        You haven't connected any institutions yet. Please go to
                        the "Search institutions" tab to connect your
                        institution now.
                      </h2>
                    )}
                  </div>
                </TabPane>
                <TabPane tab="Your Accounts" key="3">
                  {accountList.length > 0 ? (
                    <List
                      bordered
                      dataSource={accountList}
                      renderItem={account =>
                        account.type === 'CHECKING' ? (
                          <List.Item>
                            <List.Item.Meta
                              title={
                                <Link
                                  to={{
                                    pathname: `/app/link/account/${account.name}`,
                                    account: account.guid,
                                  }}
                                  key={account.guid}>
                                  {account.institutionCode +
                                    ': ' +
                                    account.name}
                                </Link>
                              }
                              description={
                                'Current Balance: ' +
                                numeral(account.balance).format('$0,0.00')
                              }
                            />
                          </List.Item>
                        ) : (
                          <List.Item>
                            <List.Item.Meta
                              title={
                                <Link
                                  to={{
                                    pathname: `/app/link/account/${account.name}}`,
                                    account: account.guid,
                                  }}
                                  key={account.guid}>
                                  {account.institutionCode +
                                    ': ' +
                                    account.name}
                                </Link>
                              }
                              description={
                                'Balance: ' +
                                numeral(account.balance).format('$0,0.00')
                              }
                            />
                          </List.Item>
                        )
                      }
                    />
                  ) : (
                    <h2>
                      You haven't connected any institutions yet. Please go to
                      the "Search institutions" tab to connect your institution
                      now.
                    </h2>
                  )}
                </TabPane>
                <TabPane tab="Your Transactions" key="4"> */}
              {/* {transactionList.length > 0 ? (
                    <List
                      bordered
                      dataSource={transactionList}
                      renderItem={transaction => (
                        <List.Item>
                          <List.Item.Meta
                            title={transaction.category}
                            description={
                              transaction.originalDescription +
                              ': ' +
                              numeral(transaction.amount).format('$0,0.00')
                            }
                          />
                        </List.Item>
                      )}
                    />
                  ) : (
                    <h2>
                      You haven't connected any institutions yet. Please go to
                      the "Search institutions" tab to connect your institution
                      now.
                    </h2>
                  )}
                </TabPane> */}
            </Tabs>
          </Widget>
          <Drawer
            title="Update your account credentials"
            // width={720}
            keyboard
            closable={false}
            destroyOnClose={true}
            onClose={cancelEdit}
            visible={showDrawer}>
            <MemberEdit member={memberEdit} onCancel={cancelEdit} />
          </Drawer>
        </Auxiliary>
      )}
    </div>
  );
};

export default Plaid;
